module.exports = __webpack_public_path__ + "img/user.e9c6d6d7.png";